var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('action-bar',[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":"/settlements/create-request"}},[_vm._v("\n            "+_vm._s(_vm.$t('settlement.btn.add_settlement_request'))+"\n        ")])],1),_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }